import { render, staticRenderFns } from "../../assets/templates/MicroService/MicroService.html?vue&type=template&id=56b3d1c2&scoped=true&"
import script from "../../assets/scripts/MicroService/MicroService.js?vue&type=script&lang=js&"
export * from "../../assets/scripts/MicroService/MicroService.js?vue&type=script&lang=js&"
import style0 from "../../assets/scss/microService.scss?vue&type=style&index=0&id=56b3d1c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b3d1c2",
  null
  
)

export default component.exports